import { LifeBuoy } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { ReportIssueDialog } from "@/components/feedback/report-issue-dialog";

type DealKind = "request" | "quote" | "order";

interface DealSupportButtonProps {
  kind: DealKind;
  reference: string;
  context?: string;
  variant?: "outline" | "ghost";
  size?: "sm" | "default";
  className?: string;
}

const KIND_LABELS: Record<DealKind, { word: string; titlePrefix: string }> = {
  request: { word: "request", titlePrefix: "Help with request" },
  quote: { word: "quote", titlePrefix: "Help with quote" },
  order: { word: "order", titlePrefix: "Help with order" },
};

export function DealSupportButton({
  kind,
  reference,
  context,
  variant = "outline",
  size = "sm",
  className,
}: DealSupportButtonProps) {
  const labels = KIND_LABELS[kind];

  return (
    <ReportIssueDialog
      context={{
        titlePrefix: labels.titlePrefix,
        issueRef: reference,
        errorMessage: context,
        pageUrl:
          typeof window !== "undefined" ? window.location.href : undefined,
      }}
    >
      <Button type="button" variant={variant} size={size} className={className}>
        <LifeBuoy className="mr-2 h-3.5 w-3.5" />
        Get help with this {labels.word}
      </Button>
    </ReportIssueDialog>
  );
}
